export class ImportarProdutoArquivoRequest {
    public arquivoBase64: string = '';
}
